import BoomIcon from "../../assets/BoomIcon";

export const NoMatch = () => {
  return (
    <div className="flex justify-center items-center min-h-[calc(100vh-120px)]">
      <BoomIcon className="overflow-visible" />
    </div>
  );
};
